(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["md-native-commerce"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('md-native-commerce')) {
    customElements.define('md-native-commerce', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.dialog = this.querySelector('[data-md-dialog]');
        this.spotlight = this.querySelector('[data-md-spotlight]');
        this.fallback = this.querySelector('[data-md-fallback]');
        this.cache = new Map();
        this.shown = new Set();
        this.count = Number(this.readSession('count') || 0);
        this.dismissed = this.readSession('dismissed') === 'true';
        this.refreshVersion = 0;
        this.giftBusy = null;
        this.giftBlockedSignature = null;
        const options = { signal: this.events.signal };
        ['on:cart:add', 'on:cart:after-merge', 'on:cart:change'].forEach((name) => {
          document.addEventListener(name, () => this.scheduleGift(), options);
        });
        document.addEventListener('click', (event) => {
          const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
          if (checkout && this.giftActive && !this.giftCheckoutPass) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.checkoutWithGift(() => checkout.click());
          }
        }, { ...options, capture: true });
        document.addEventListener('submit', (event) => {
          if (event.submitter?.name === 'checkout' && this.giftActive && !this.giftCheckoutPass) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.checkoutWithGift(() => event.target.requestSubmit(event.submitter));
          }
        }, { ...options, capture: true });
        this.scheduleGift();
        document.addEventListener('on:cart:add', (event) => this.onCartAdd(event), options);
        document.addEventListener('on:cart:after-merge', () => this.refreshSlots(), options);
        document.addEventListener('on:cart:change', () => this.refreshSlots(), options);
        document.addEventListener('shopify:section:load', () => this.refreshSlots(), options);
        document.addEventListener('submit', (event) => {
          if (event.target.matches('[data-md-add]')) this.addPick(event);
        }, options);
        document.addEventListener('change', (event) => {
          if (event.target.matches('[data-md-add] select')) {
            const option = event.target.selectedOptions[0];
            if (option.dataset.price) event.target.closest('.md-pick').querySelector('[data-md-price]').textContent = option.dataset.price;
          }
        }, options);
        this.querySelectorAll('[data-md-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('close', () => {
          if (document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          else location.assign(`${this.dataset.root}cart`);
          this.scheduleSpotlight(Number(this.dataset.interval) * 1000);
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.querySelector('[data-md-dismiss]').addEventListener('click', () => {
          this.dismissed = true;
          this.writeSession('dismissed', 'true');
          this.hideSpotlight();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) clearTimeout(this.hideTimer);
          else if (!this.spotlight.hidden) this.hideTimer = setTimeout(() => this.finishSpotlight(), Number(this.dataset.duration) * 1000);
        }, options);
        document.addEventListener('on:cart-drawer:before-open', () => this.hideSpotlight(), options);
        this.spotlightObserver = new MutationObserver(() => {
          if (!this.spotlight.hidden && this.overlayOpen()) this.hideSpotlight();
        });
        this.spotlightObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'open', 'class'] });
        this.refreshSlots();
        this.scheduleSpotlight(Number(this.dataset.delay) * 1000);
      }
      disconnectedCallback() {
        this.events.abort();
        this.spotlightObserver.disconnect();
        clearTimeout(this.spotlightTimer);
        clearTimeout(this.hideTimer);
        clearTimeout(this.refreshTimer);
        clearTimeout(this.giftTimer);
      }
      readSession(key) { try { return sessionStorage.getItem(`md-picks-${key}`); } catch { return null; } }
      writeSession(key, value) { try { sessionStorage.setItem(`md-picks-${key}`, value); } catch {} }
      async cart() {
        const response = await fetch(`${this.dataset.root}cart.js`, { signal: this.events.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }
      get giftActive() {
        return this.dataset.giftEnabled === 'true' && Boolean(this.dataset.giftVariant);
      }
      scheduleGift() {
        if (!this.giftActive) return;
        clearTimeout(this.giftTimer);
        this.giftTimer = setTimeout(() => this.syncGift().catch(() => {}), 400);
      }
      async checkoutWithGift(proceed) {
        if (this.giftCheckingOut) return;
        this.giftCheckingOut = true;
        try {
          for (let attempt = 0; document.querySelector('.cart-form--refreshing, .merge-item-refreshing'); attempt += 1) {
            if (attempt >= 40) throw new Error(this.dataset.giftError);
            await new Promise((resolve) => setTimeout(resolve, 200));
          }
          await this.syncGift();
          this.giftCheckoutPass = true;
          proceed();
        } catch {
          window.alert(this.dataset.giftError);
        } finally {
          this.giftCheckingOut = false;
          setTimeout(() => { this.giftCheckoutPass = false; }, 0);
        }
      }
      syncGift() {
        if (!this.giftActive) return Promise.resolve();
        if (!this.giftBusy) this.giftBusy = this.reconcileGift().finally(() => { this.giftBusy = null; });
        return this.giftBusy;
      }
      async reconcileGift() {
        let cart = await this.cart();
        const variantId = String(this.dataset.giftVariant);
        const giftLines = () => cart.items.filter((item) => String(item.variant_id) === variantId);
        const merchandise = cart.items.filter((item) => String(item.variant_id) !== variantId);
        const signature = JSON.stringify([cart.currency, merchandise.map((item) => [item.key, item.quantity, item.final_line_price]), cart.cart_level_discount_applications]);
        const subtotal = merchandise.reduce((total, item) => total + item.final_line_price, 0);
        const eligible = cart.currency === 'USD' && subtotal >= Number(this.dataset.giftThreshold);
        let changed = false;
        const mutate = async (endpoint, payload) => {
          const response = await fetch(`${this.dataset.root}cart/${endpoint}.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          });
          if (!response.ok) throw new Error(this.dataset.giftError);
          cart = endpoint === 'add' ? await this.cart() : await response.json();
          changed = true;
        };
        const removeGifts = async () => {
          const updates = Object.fromEntries(giftLines().map((item) => [item.key, 0]));
          if (Object.keys(updates).length) await mutate('update', { updates });
        };
        if (!eligible) {
          await removeGifts();
        } else if (this.giftBlockedSignature !== signature) {
          if (giftLines().length > 1 || giftLines().some((item) => item.quantity !== 1 || item.properties?._md_gift !== 'mystery-85')) await removeGifts();
          if (!giftLines().length) await mutate('add', { items: [{ id: variantId, quantity: 1, properties: { _md_gift: 'mystery-85' } }] });
          if (giftLines().some((item) => item.final_line_price !== 0)) {
            this.giftBlockedSignature = signature;
            await removeGifts();
          }
        } else {
          await removeGifts();
        }
        if (changed) {
          const targets = [...document.querySelectorAll('page-header, cart-form')];
          const sectionIds = [...new Set(targets.map((target) => target.dataset.sectionId).filter(Boolean))];
          const url = new URL(location.pathname, location.origin);
          url.searchParams.set('sections', sectionIds.join(','));
          const response = await fetch(url);
          if (!response.ok) throw new Error(this.dataset.giftError);
          const sections = await response.json();
          if (sectionIds.some((id) => !sections[id])) throw new Error(this.dataset.giftError);
          targets.forEach((target) => {
            const html = sections[target.dataset.sectionId];
            if (target.tagName === 'CART-FORM') target.refreshFromHtml(html);
            else target.updateFromCartChange(html);
          });
        }
        return cart;
      }
      async candidates(productId) {
        if (!productId) return [];
        if (this.cache.has(String(productId))) return this.cache.get(String(productId));
        const result = [];
        for (const intent of ['complementary', 'related']) {
          try {
            const url = new URL(this.dataset.recommendations, location.origin);
            url.search = new URLSearchParams({ section_id: 'md-recommendations', product_id: productId, limit: '10', intent });
            const response = await fetch(url, { signal: this.events.signal });
            if (!response.ok) continue;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const template = doc.querySelector('[data-md-recommendations]');
            if (template) result.push(...template.content.querySelectorAll('.md-pick'));
            if (result.length >= 6) break;
          } catch (error) { if (error.name === 'AbortError') throw error; }
        }
        this.cache.set(String(productId), result);
        return result;
      }
      async cards(productId, cart, max = 3, matchTitle) {
        const excluded = new Set(cart.items.map((item) => String(item.product_id)));
        excluded.add(String(productId));
        excluded.add(this.dataset.giftProduct);
        const nodes = [...await this.candidates(productId), ...this.fallback.content.querySelectorAll('.md-pick')];
        const fragment = document.createDocumentFragment();
        let count = 0;
        for (const node of nodes) {
          const id = node.dataset.mdProduct;
          if (excluded.has(id)) continue;
          excluded.add(id);
          const card = node.cloneNode(true);
          const select = card.querySelector('select');
          if (matchTitle && matchTitle !== 'Default Title') {
            const match = [...select.options].find((option) => !option.disabled && option.dataset.title === matchTitle);
            if (match) {
              select.value = match.value;
              card.querySelector('[data-md-price]').textContent = match.dataset.price;
            }
          }
          fragment.append(card);
          if (++count >= max) break;
        }
        return fragment;
      }
      refreshSlots() {
        if (this.dataset.pairings !== 'true') return;
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.loadSlots(), 100);
      }
      async loadSlots() {
        const version = ++this.refreshVersion;
        try {
          const slots = [...document.querySelectorAll('[data-md-picks]')];
          if (!slots.length) return;
          const cart = await this.cart();
          await Promise.all(slots.map(async (slot) => {
            const firstItem = cart.items.find((item) => String(item.product_id) !== this.dataset.giftProduct);
            const productId = slot.dataset.productId && slot.dataset.productId !== this.dataset.giftProduct ? slot.dataset.productId : firstItem?.product_id;
            if (!productId) { slot.hidden = true; return; }
            const cards = await this.cards(productId, cart, slot.classList.contains('md-picks-slot--drawer') ? 2 : 3);
            if (version !== this.refreshVersion || !slot.isConnected) return;
            slot.querySelector('[data-md-grid]').replaceChildren(cards);
            slot.hidden = !slot.querySelector('.md-pick');
          }));
        } catch {}
      }
      async onCartAdd(event) {
        this.refreshSlots();
        if (this.dataset.popup !== 'true' || this.popupLoading || this.dialog.open) return;
        if (window.theme?.settings?.afterAddToCart === 'page' || window.theme?.settings?.afterAddToCart === 'no-js') return;
        this.popupLoading = true;
        try {
          await this.syncGift();
          const cart = await this.cart();
          const trigger = cart.items.find((item) => String(item.variant_id) === String(event.detail?.variantId));
          if (!trigger || this.shown.has(trigger.product_id)) return;
          const cards = await this.cards(trigger.product_id, cart, 3, trigger.variant_title);
          if (!cards.childElementCount || !this.isConnected) return;
          this.querySelector('[data-md-popup-grid]').replaceChildren(cards);
          this.shown.add(trigger.product_id);
          this.hideSpotlight();
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
          await new Promise((resolve) => setTimeout(resolve, 350));
          if (this.isConnected && !document.hidden) this.dialog.showModal();
        } catch {} finally { this.popupLoading = false; }
      }
      async addPick(event) {
        event.preventDefault();
        const form = event.target;
        const button = form.querySelector('button');
        if (button.disabled || !form.reportValidity()) return;
        const select = form.querySelector('select');
        const status = form.querySelector('[data-md-status]');
        button.disabled = true;
        select.disabled = true;
        button.textContent = this.dataset.addingLabel;
        status.textContent = '';
        const sections = [...document.querySelectorAll('page-header, cart-drawer')];
        try {
          const response = await fetch(`${this.dataset.root}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: select.value, quantity: 1 }],
              sections: sections.map((section) => section.dataset.sectionId),
              sections_url: location.pathname
            })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.errorLabel);
          status.textContent = this.dataset.addedLabel;
          button.textContent = this.dataset.addedLabel;
          form.dataset.added = 'true';
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || sections.some((section) => !data.sections?.[section.dataset.sectionId])) {
            location.assign(`${this.dataset.root}cart`);
            return;
          }
          sections.forEach((section) => section.updateFromCartChange(data.sections[section.dataset.sectionId]));
          await this.syncGift();
          drawer.querySelector('.cart-drawer__content').scrollTop = 0;
          if (this.dialog.open) this.dialog.close();
          else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          drawer.querySelector('.drawer__close-btn').focus({ preventScroll: true });
          this.refreshSlots();
        } catch (error) {
          if (form.dataset.added === 'true') { location.assign(`${this.dataset.root}cart`); return; }
          status.textContent = error.message || this.dataset.errorLabel;
          button.disabled = false;
          select.disabled = false;
          button.textContent = this.dataset.addLabel;
        }
      }
      overlayOpen() {
        return Boolean(document.querySelector('dialog[open], [role="dialog"][aria-hidden="false"], .klaviyo-form[aria-modal="true"], .needsclick[role="dialog"], .drawer[open], .drawer.is-open'));
      }
      hideSpotlight() {
        this.spotlight.hidden = true;
        clearTimeout(this.hideTimer);
        this.scheduleSpotlight(Number(this.dataset.interval) * 1000);
      }
      scheduleSpotlight(delay) {
        clearTimeout(this.spotlightTimer);
        if (this.dataset.spotlight !== 'true' || this.dismissed || this.count >= Number(this.dataset.limit)) return;
        this.spotlightTimer = setTimeout(() => this.showSpotlight(), delay);
      }
      showSpotlight() {
        if (this.dismissed || !this.isConnected) return;
        if (document.hidden || this.overlayOpen() || location.pathname.includes('/cart') || (this.dataset.mobile !== 'true' && matchMedia('(max-width: 600px)').matches)) {
          this.scheduleSpotlight(5000);
          return;
        }
        const products = [...this.fallback.content.querySelectorAll('.md-pick')].filter((node) => node.dataset.mdProduct !== this.dataset.productId && node.dataset.mdProduct !== this.dataset.giftProduct);
        if (!products.length) return;
        const product = products[this.count % products.length];
        this.querySelector('[data-md-spotlight-link]').href = product.querySelector('.md-pick__title').href;
        this.querySelector('[data-md-spotlight-title]').textContent = product.querySelector('.md-pick__title').textContent;
        this.querySelector('[data-md-spotlight-price]').textContent = product.querySelector('[data-md-price]').textContent;
        const img = product.querySelector('img')?.cloneNode(true);
        if (img) { img.loading = 'eager'; img.alt = ''; }
        this.querySelector('[data-md-spotlight-image]').replaceChildren(...(img ? [img] : []));
        this.spotlight.hidden = false;
        this.count += 1;
        this.writeSession('count', String(this.count));
        this.hideTimer = setTimeout(() => {
          if (this.spotlight.matches(':hover') || this.spotlight.contains(document.activeElement)) {
            this.hideTimer = setTimeout(() => this.finishSpotlight(), 10000);
          } else this.finishSpotlight();
        }, Number(this.dataset.duration) * 1000);
      }
      finishSpotlight() {
        if (this.spotlight.contains(document.activeElement)) {
          this.hideTimer = setTimeout(() => this.finishSpotlight(), 5000);
          return;
        }
        this.hideSpotlight();
        this.scheduleSpotlight(Number(this.dataset.interval) * 1000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
